import { ssoClient } from '@better-auth/sso/client'
import { createAuthClient } from 'better-auth/react'

export function isBetterAuthEnabled(): boolean {
  return Boolean(window._env_?.BETTER_AUTH_URL?.trim())
}

export function getBetterAuthConfig() {
  const url = new URL(
    window._env_?.BETTER_AUTH_URL?.trim() || '/api/auth',
    window.location.origin,
  )
  if (
    url.origin !== window.location.origin ||
    url.username ||
    url.password ||
    url.search ||
    url.hash
  ) {
    throw new Error('Better Auth must use a path on this Portal origin.')
  }
  return {
    baseUrl: url.toString().replace(/\/$/, ''),
    providerId: window._env_?.BETTER_AUTH_AUTH0_PROVIDER_ID?.trim() || '',
  }
}

function createClient(baseURL: string) {
  return createAuthClient({ baseURL, plugins: [ssoClient()] })
}

let client: ReturnType<typeof createClient> | undefined
let clientBaseUrl: string | undefined

/** Build lazily so Auth0-only deployments never contact Better Auth. */
export function getAuthClient() {
  const { baseUrl } = getBetterAuthConfig()
  if (!client || clientBaseUrl !== baseUrl) {
    client = createClient(baseUrl)
    clientBaseUrl = baseUrl
  }
  return client
}
